import { SiteFeature } from "src/js/stores/siteGeometry/store";
import { SiteHatch } from "./SiteHatch";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { useSiteStagesById } from "react-migration/domains/sites/hooks/useSiteStages";

interface SiteButtonProps {
  site: SiteFeature;
  onClick(): void;
}

export function SiteButton({ site, onClick }: SiteButtonProps) {
  const { t } = useTranslation();
  const stagesById = useSiteStagesById();
  const stage = stagesById[site.properties._stage._id];
  const stageName = stage?.name || "…";
  const stageHidden = stage?.hidden ?? false;

  return (
    <div className="flex">
      <button
        key={site.id}
        data-testid="site-button"
        title={site.properties.title}
        className="w-full p-1.5 gap-x-2 border-solid hover:bg-neutral-100 flex justify-start text-left text-text-base-active hover:text-text-base-active-hover items-start"
        onClick={onClick}
      >
        <SiteHatch stageColor={site.properties.color} />
        <div className="flex flex-col overflow-hidden grow">
          <span className="truncate">{site.properties.title}</span>
          <span className="items-center text-xs font-semibold text-text-base-tertiary">
            <span className="truncate">{stageName}</span>
            <span>{stageHidden && ` ${t("sites.save_site.save_site_dropdown.hidden")}`}</span>
          </span>
        </div>
      </button>
    </div>
  );
}
